import React, { useState, useEffect } from "react";
import "./NuCar.css";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { addcarnum } from "../../Redux/actions/NumCaration";
import insurance from "../../assets/insurance.svg";
// import Logo from "../../images/logo.png";
import car from "../../assets/icons/car.png";
import axios from "axios";
import axiosInCar from "../../Redux/axios/AxiosInCar";
import { NavbarJourney } from "../Navbar/NavbarJourney";
import { Form, Input, Button, Select, Row, Col, Spin, message } from "antd/lib";
import { addVahanData } from "../../Redux/actions/NumBikeation";
import { addcardetails } from "../../Redux/actions/NumCaration";

export default function Numcar() {
  const [formLayout] = useState("vertical");
  const history = useHistory();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { Option } = Select;
  const [open, setopen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [BaseUrl, setBaseURL] = useState("");
  const ProdType = useSelector((state) => state?.common?.productType);
  const CarMakeData = useSelector((state) => state?.cardetail?.carMakeData);
  const isuser = JSON.parse(localStorage.getItem("vibeUser"));

  useEffect(() => {
    const BASEURL = process.env.REACT_APP_UAT_BASE_URL;
    setBaseURL(BASEURL);
  }, [BaseUrl]);

  const prefixSelector = (
    <Select
      style={{
        width: 70,
      }}
      defaultValue="+91"
    >
      <Option value="+91">+91</Option>
    </Select>
  );
  const handleClear = () => {
    form.resetFields();
  };
  const onFinish = (values) => {
    // console.log(values)
    setLoading(true);
    setopen(true);
    if (isuser !== null) {
      var is_POSP = isuser.isPOSP === true ? 1 : 0;
      var posp_id = isuser.isPOSP === true ? isuser.pospid : "";
    } else {
      is_POSP = 0;
      posp_id = "";
    }
    const url = `${BaseUrl}v2/car_insurances/register`;
    axios
      .post(url, {
        car_number: values.carNumber,
        phonenumber: values.phonenumber,
        isPOSP: is_POSP,
        posp_id: posp_id,
      })
      .then((res) => {
        // console.log(res);
        if (res.status === 200) {
          let data = res.data.data;
          dispatch(addcarnum(data));
          axiosInCar
            .post("getVehicleDetails", {
              vehicleNumber: values.carNumber,
            })
            .then((res) => {
              // console.log(res)
              let carResult = res.data.data;
              const { vibe_master } = carResult;
              // console.log(carResult)
              dispatch(addVahanData(carResult));
              dispatch(
                addcardetails({
                  ...CarMakeData,
                  make: vibe_master?.Make,
                  model: vibe_master?.Model,
                  varbike: vibe_master?.Variant,
                  VehicleCoreCode: vibe_master?.Vehicle_Core_Code,
                })
              );
              if (ProdType === vibe_master?.Product_Type) {
                history.push("/cardetail");
              } else {
                message.info(
                  "Entered Vehicle Number is MisMatched with Selected Product"
                );
                setLoading(false);
                setopen(false);
              }
            })
            .catch((err) => {
              console.log(err);
              setLoading(false);
            });
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setopen(false);
      });
  };
  const onFinishFailed = (values) => {
    console.log(values);
  };
  const handleInputChange = (e) => {
    e.target.value = e.target.value.toUpperCase();
    form.setFieldsValue({ carNumber: e.target.value });
  };
  return (
    <>
      <Spin spinning={open}>
        <NavbarJourney />
        <section
          className="bg-light d-flex align-items-center justify-content-center"
          style={{ minHeight: "calc(100vh - 50px)" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-xl-6 col-md-6 img-0 col-sm-0  p-2 ">
                <div className="m-4">
                  {/* <LazyLoad height={200} offset={100}> */}
                  <img
                    className="img-fluid"
                    src={insurance}
                    width={500}
                    alt=""
                  />
                  {/* </LazyLoad> */}
                </div>
              </div>
              {/* <div className="col-md-6 col-sm-12 p-2"> */}
              <div className="col-xl-6 col-md-6 col-sm-12 p-2 d-flex flex-column justify-content-center align-items-center p-4 outer-insur">
                {/* <div className="text-center">
                <img src={Logo} alt="" style={{ maxWidth: "250px" }} />
              </div> */}
                <h4 className="text-blue text-center">
                  Save upto 85%* on Four Wheeler Insurance
                </h4>
                <p className="my-3">Stay home & renew in 2 minutes</p>
                <div className="d-flex align-items-center mt-4">
                  <img
                    style={{ width: 20 }}
                    src="https://firebasestorage.googleapis.com/v0/b/goodfood-659aa.appspot.com/o/Icons%2FBike_Ins%2Fflash.png?alt=media&token=c7213ae8-4a09-4a72-9800-e6eb5e59ff75"
                    alt=""
                  />
                  <small className="me-4 ms-2 text-success fw-bold">
                    Instant Policy
                  </small>
                  <img
                    style={{ width: 20 }}
                    src="https://firebasestorage.googleapis.com/v0/b/goodfood-659aa.appspot.com/o/Icons%2FBike_Ins%2Fbank.png?alt=media&token=4cc16690-6e13-4219-a6ff-dd513fe04d1f"
                    alt=""
                  />
                  <small className="me-4 ms-2 text-warning fw-bold">
                    Best Prices
                  </small>
                  <img
                    style={{ width: 20 }}
                    src="https://firebasestorage.googleapis.com/v0/b/goodfood-659aa.appspot.com/o/Icons%2FBike_Ins%2Fdocuments.png?alt=media&token=7923cd01-4150-4801-a4bf-8a42120125c9"
                    alt=""
                  />
                  <small className="me-4 ms-2 text-info fw-bold">
                    No Paperwork
                  </small>
                </div>
                <Form
                  layout={formLayout}
                  form={form}
                  style={{ width: "70%", paddingTop: "30px" }}
                  requiredMark={false}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                >
                  <Form.Item
                    name="carNumber"
                    rules={[
                      {
                        pattern: /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,2}[0-9]{3,4}$/i,
                        message: "Invalid Vehicle No",
                      },
                      { required: true, message: "Enter Vehicle No" },
                    ]}
                  >
                    <Input
                      onChange={handleInputChange}
                      placeholder="Enter Car Number (eg. DL1SAB1234)"
                    ></Input>
                  </Form.Item>
                  <Form.Item
                    name="phonenumber"
                    rules={[
                      {
                        pattern: /^([0|+[0-9]{1,5})?([6-9][0-9]{9})$/,
                        message: "Invalid Mobile No",
                      },
                      { required: true, message: "Enter Mobile No" },
                    ]}
                  >
                    <Input
                      maxLength={10}
                      addonBefore={prefixSelector}
                      placeholder="Enter Mobile Number (eg. 9876543210)"
                    ></Input>
                  </Form.Item>
                  <Row gutter={24} className="justify-content-center">
                    <Col span={12}>
                      <Form.Item>
                        <Button
                          style={{ width: "100%", borderRadius: "7px" }}
                          // loading={loading}
                          type="primary"
                          htmlType="submit"
                        >
                          View Price
                        </Button>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item>
                        <Button
                          className="clear-button-ant"
                          type="primary"
                          onClick={handleClear}
                        >
                          Clear
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
                {/* <TextField
                className="w-75 mt-4"
                error={fieldflag}
                id="standard-error-helper-text"
                label={fieldflag ? "error" : "Enter Car Number"}
                placeholder="Enter Car Number (eg. DL1SAB1234)"
                value={carno}
                pattern="[A-Z]{2}[0-9]{1}[A-Z]{2}[0-9]{4}"
                onChange={(e) => {
                  setCarno(e.target.value.toUpperCase());
                }}
                helperText={fieldflag ? "Incorrect entry." : ""}
                variant="outlined"
                required
              />
              <TextField
                className="w-75 my-4"
                error={fieldflag}
                id="standard-error-helper-text"
                label={fieldflag ? "error" : "Enter Mobile Number"}
                placeholder="Enter Mobile Number (eg. 9876543210)"
                value={mobileno}
                pattern="[0-9]{10}"
                onChange={(e) => {
                  setMobileno(e.target.value.toUpperCase());
                }}
                helperText={fieldflag ? "Incorrect entry." : ""}
                variant="outlined"
                required
              />
              <Button
                style={{ background: "#273592" }}
                className="w-75 mb-5"
                variant="contained"
                onClick={() => {
                  if (
                    carno !== "" &&
                    /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,2}[0-9]{3,4}$/i.test(carno) &&
                    /^([0|+[0-9]{1,5})?([7-9][0-9]{9})$/.test(mobileno)
                  ) {
                    if (isuser !== null) {
                      var is_POSP = isuser.isPOSP === true ? 1 : 0;
                      var posp_id = isuser.isPOSP === true ? isuser.pospid : "";
                    } else {
                      is_POSP = 0;
                      posp_id = "";
                    }

                    setFieldflag(false);
                    setOpen(true);
                    const url =
                      "https://insurance.tridentnets.com/api/v1/car_number_register";
                    axios
                      .post(url, {
                        car_number: carno,
                        phonenumber: mobileno,
                        isPOSP: is_POSP,
                        posp_id: posp_id,
                      })
                      .then((res) => {
                        console.log(res);
                        if (res.status === 200) {
                          let data = res.data.data;
                          localStorage.setItem("vibeReg", JSON.stringify(data));
                          const Url1 = "https://insurance.tridentnets.com/api/getVehicleDetails";
                        axios
                        .post(Url1, {
                          vehicleNumber: carno,
                        }).then((res)=> {
                          console.log(res)
                          let carResult = res.data.data;
                          console.log(carResult.result)
                          localStorage.setItem("carResult", JSON.stringify(carResult?.result));
                          dispatch(addcarnum( carResult?.result));
                          // setSubmitting(false);
                          setOpen(false);
                        }).catch((err)=>{
                          console.log(err)
                        })
                          // dispatch(addcarnum(carno));
                          // setOpen(false);
                        }
                      });
                  } else {
                    setFieldflag(true);
                    setOpen(false);
                  }
                }}
              >
                View Prices
              </Button> */}
                <div className="h6 text-center" style={{ fontSize: "0.7rem" }}>
                  <img
                    className="mx-1"
                    style={{ maxHeight: "0.8rem" }}
                    src={car}
                    alt=""
                  />{" "}
                  <Link
                  // to="/"
                  >
                    Don't have a car number?
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Spin>
    </>
  );
}
